
import { Utilidades } from "@/Util/Utilidades";
import Vue from "vue";

export default Vue.extend({
  name: "FileInput",
  props: {
    label: {
      type: String,
      default: Utilidades.traduccion({ texto: "Fichero", tag: "FICHERO" }),
    },
    accept: {
      type: String,
      default: "*",
    },
    prepend_icon: {
      type: String,
      default: "mdi-paperclip",
    },
    placeholder: {
      type: String,
      default: Utilidades.traduccion({ texto: "Seleccione el fichero", tag: "SELECCIONE_EL_FICHERO" }),
    },
    small_chips: {
      type: Boolean,
      default: true,
    },
    show_size: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    counter: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    action: Function,
  },
  data() {
    return {
      file: null as File,
    };
  },
  mounted(){
   },
  components: {},
  methods: {
  },
});
